import { routerMiddleware }                                   from 'connected-react-router';
import { createBrowserHistory, createMemoryHistory, History } from 'history';
import { applyMiddleware, compose, createStore, Store }       from 'redux';
import { createLogger }                                       from 'redux-logger';
import thunkMiddleware                                        from 'redux-thunk';

import { isServer }      from '../../utils';
import createRootReducer from './reducers';

const loggerMiddleware = createLogger();

const composeEnhancers = (typeof window !== 'undefined') && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function(url = '/'): {store: Store<any>, history: History} {

    /** Create a history depending on the environment */
    const history = isServer ? createMemoryHistory({initialEntries: [url]}) : createBrowserHistory();

    const initialState = !isServer ? (window as any).__INITIAL_STATE__ : {};

    const middlewares = [thunkMiddleware, routerMiddleware(history)];

    const store = createStore(
        createRootReducer(history),
        initialState,
        composeEnhancers(applyMiddleware(...middlewares)),
    );

    return { store, history };
}
